import React, { useState } from 'react';
import { createMember } from './api';

interface RegisterMemberFormProps {
  onSuccess?: (member: any) => void;
}

const RegisterMemberForm: React.FC<RegisterMemberFormProps> = ({ onSuccess }) => {
  const [form, setForm] = useState({
    student_first_name: '',
    student_last_name: '',
    parent_first_name: '',
    parent_last_name: '',
    contact_emails: '',
    contact_phone: '',
    source: '',
    address_line1: '',
    student_birthdate: '',
    membership_type: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const member = await createMember({
        ...form,
        contact_emails: form.contact_emails.split(',').map((e) => e.trim()),
      });
      setSuccess(true);
      if (onSuccess) onSuccess(member);
    } catch (err: any) {
      setError(err.message || 'Failed to register member');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-lg mx-auto bg-white p-8 rounded shadow space-y-4">
      <h2 className="text-2xl font-bold mb-4">Register New Member</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input name="student_first_name" value={form.student_first_name} onChange={handleChange} placeholder="Student First Name" required className="border p-2 rounded" />
        <input name="student_last_name" value={form.student_last_name} onChange={handleChange} placeholder="Student Last Name" required className="border p-2 rounded" />
        <input name="parent_first_name" value={form.parent_first_name} onChange={handleChange} placeholder="Parent First Name (if minor)" className="border p-2 rounded" />
        <input name="parent_last_name" value={form.parent_last_name} onChange={handleChange} placeholder="Parent Last Name (if minor)" className="border p-2 rounded" />
        <input name="contact_emails" value={form.contact_emails} onChange={handleChange} placeholder="Contact Email(s), comma separated" required className="border p-2 rounded" />
        <input name="contact_phone" value={form.contact_phone} onChange={handleChange} placeholder="Contact Phone" className="border p-2 rounded" />
        <input name="address_line1" value={form.address_line1} onChange={handleChange} placeholder="Address" className="border p-2 rounded" />
        <input name="student_birthdate" value={form.student_birthdate} onChange={handleChange} placeholder="Birthdate (YYYY-MM-DD)" className="border p-2 rounded" />
        <select name="membership_type" value={form.membership_type} onChange={handleChange} className="border p-2 rounded">
          <option value="">Select Membership Type</option>
          <option value="trial">Trial</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>
        <input name="source" value={form.source} onChange={handleChange} placeholder="Source (e.g. Website)" className="border p-2 rounded" />
      </div>
      <button type="submit" className="bg-gold text-navy font-bold py-2 px-4 rounded" disabled={loading}>
        {loading ? 'Registering...' : 'Register Member'}
      </button>
      {error && <div className="text-red-600 mt-2">{error}</div>}
      {success && <div className="text-green-600 mt-2">Member registered successfully!</div>}
    </form>
  );
};

export default RegisterMemberForm;
